export default __webpack_public_path__ + "static/media/ch.46709648.svg";